<template>
  <div class="main">
    <div v-for="i in guideConf.length" class="preload-image" :id="'preload-'+i"></div>
    <div class="slogan">
      <img src="../../static/image/slogan.png" alt="我的轻橙 你的倾心">
    </div>
    <div class="logo">
      <h1>
        <img src="../../static/image/logo.png" alt="我的轻橙 你的倾心" class="logo-bd">
      </h1>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {ComponentName, Methods} from '../const/common';

  export default {
    name: "start",
    computed: {
      ...mapState(['moduleState', 'guideConf'])
    },
    mounted() {
      if (window.iOSinfo) {
        var _res = Methods.boxVerJudge('ibox', '2.11.0425');

        window.webkit.messageHandlers.iOSWKMethod.postMessage({
          key: "changeGoBack",
          data: {isDefault: !_res},
          callBack: 'iboxGoBack'
        });
      }
      if (window.org_box) {
        if (org_box.setCloseSign) {
          org_box.setCloseSign("true");
        }

        if (org_box.Close) {
          window.aBoxBack = function () {
            Methods.messageConfirm('', '确认退出吗？', '确认', '取消', function () {
              org_box.Close();
            }, null);
          };
        }
      }

      setTimeout(() => {
        Methods.cutComponent([ComponentName.START], false);
      }, 2000);
    }
  }
</script>
<style scoped>
  @import "../style/css/start.css";
</style>



// WEBPACK FOOTER //
// src/components/start.vue